import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";
import { titles } from "@/mocks/titles";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function TvCategoryPage() {
  usePageMeta(
    "奇优影院-热门电视剧分类浏览",
    "奇优影院电视剧分类页，按剧集类型、地区、年份筛选热播剧集，查看剧名、集数、主演与分集目录，快速定位想追的剧。",
    "电视剧分类,热播剧集,追剧推荐,奇优影院",
  );

  const shows = titles.filter((item) => item.type === "tv");
  const totalEpisodes = shows.reduce((sum, item) => sum + (item.episodeCount ?? 0), 0);

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-5 md:pt-7">
        <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "电视剧" }]} />

        <div className="rounded-lg bg-background-100 border border-background-200 px-4 py-5 md:px-6 md:py-7 mb-5">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
            <div>
              <h1 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
                电视剧 · 分类与追剧指南
              </h1>
              <p className="text-sm text-foreground-600 mt-2 max-w-2xl leading-relaxed">
                覆盖古装、现代、青春、悬疑等热门剧集类型，每部剧集均提供集数、主演与分集目录，帮助你判断值不值得追。
              </p>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-center">
                <p className="text-xl font-extrabold font-heading text-primary-700">{shows.length}</p>
                <p className="text-[11px] text-foreground-500">部剧集</p>
              </div>
              <div className="w-px h-8 bg-background-300" />
              <div className="text-center">
                <p className="text-xl font-extrabold font-heading text-accent-600">{totalEpisodes}</p>
                <p className="text-[11px] text-foreground-500">集可查</p>
              </div>
            </div>
          </div>
        </div>

        <CategoryBrowser items={shows} categoryLabel="剧集" />
      </div>
    </SiteLayout>
  );
}